import { useLocation } from 'react-router-dom';
import { getRouteSeo } from './routeMeta';
import { useSeo } from './useSeo';

/** Applies the SEO tags for whatever page the router is on, when they are known up front. */
export function useRouteSeo(): void {
  const { pathname } = useLocation();
  useSeo(getRouteSeo(pathname));
}
